import { RouteObject } from 'react-router-dom';
import Assets from '../Assets';
import { CreateAssets, EditAssets, ViewAsset } from '../pages';

const AssetsRoutes: RouteObject[] = [
  {
    path: 'assets',
    element: <Assets />,
  },
  {
    path: 'assets/create',
    element: <CreateAssets />,
  },
  {
    path: 'assets/:assetId/edit',
    element: <EditAssets />,
  },
  {
    path: 'assets/:assetId',
    element: <ViewAsset />,
  },
];

export default AssetsRoutes;
